import { render, staticRenderFns } from "./AttrInfo.vue?vue&type=template&id=384c2a8a&scoped=true"
import script from "./AttrInfo.vue?vue&type=script&lang=js"
export * from "./AttrInfo.vue?vue&type=script&lang=js"
import style0 from "./AttrInfo.vue?vue&type=style&index=0&id=384c2a8a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384c2a8a",
  null
  
)

export default component.exports